let config = {
	siteName: 'Magic Card Buyer',
	titleDelimiter: ' | ',
	endpoints: {
		'getItems': 'https://client.magiccardbuyer.eu/search/',
		'sendOrder': 'https://client.magiccardbuyer.eu/orders/'
	},
	eshop: {
		'minimumOrdervalue': 8,
		'maximumOrderValue': 150,
		'maximumSingleCardsNumber': 12,
		'maximumCartPersistHours': 2
	},
	webfont: {
		google: {
			families: ['Raleway:400,500,600,700:latin-ext']
		}
	},
	social: {
		'facebook': 'https://www.facebook.com/magiccardbuyereu-192765307855235/?fref=ts'
	},
	pageNames: {
		home: false,
		form: {
			step1: 'Cart',
			step2: 'Contact Info',
			step3: 'Payment Method',
			step4: 'Summary',
			step5: 'Thank you',
			key: function(n) {
				return this[Object.keys(this)[n]];
			}
		},
		noMatch: 'Error',
		privacyPolicy: 'Privacy Policy',
		termsOfUse: 'Terms of Use',
		packagingTutorial: 'Packaging Tutorial',
		howItWorks: 'How it works'
	},
	maintenanceModeOn: false,
	maintenanceModeUntil: '7 March 2018'
};

export default config;



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/